import React, { useState } from 'react';
import LatestArticles from './LatestArticles';
import { Article } from '@/types/Blog';
import Link from 'next/link';
import ReadAlsoSection from './ReadAlsoSection';
import CategoryNavigation from './CategoryNavigation';
import { SearchBar } from './SearchBar';


interface ArticleDetailProps {
  article: Article;
  sortedRelatedArticles: Article[];
}

const ArticleDetail: React.FC<ArticleDetailProps> = ({ article, sortedRelatedArticles }) => {
  // Sort related articles by time (newest first)


  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  const filteredArticles = selectedCategory
    ? sortedRelatedArticles.filter(article =>
      selectedCategory === 'All' ? true : article.category === selectedCategory
    )
    : sortedRelatedArticles;

  return (
    <div className="mt-[2rem] w-full flex flex-col items-center pb-8">
      <div className='w-[80%]'>
        <h1 className='text-3xl md:text-4xl font-bold font-body text-center text-defaultBlue mb-8'>IIT Challenge News</h1>
        <div className='flex flex-col items-center'>
          <CategoryNavigation
            selectedCategory={selectedCategory}
            onSelectCategory={setSelectedCategory}
          />
          <SearchBar />
        </div>

        <div className="flex items-center mb-2 md:mb-0">
          <Link href="/iit-news" className="mr-3 text-lg text-gray-400 font-semibold hover:text-defaultBlue transition-colors cursor-pointer">News</Link>
          <span className="mr-3 text-lg text-gray-400 font-semibold">{'>'}</span>
          <span className="text-lg text-gray-400 font-semibold">{article.category}</span>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-6 mt-[30px] z-20">
          <img alt='' src='/images/CircleDots.svg' className='absolute top-96 left-16 z-10 w-64 h-64 ' />

          <div className="lg:col-span-4  z-10 ">
            <div className='overflow-hidden w-full h-52 md:h-96  relative rounded-t-md shadow'>
              <div className='w-full h-52 md:h-96 hover:scale-[1.025] transition-all duration-700 absolute top-0 left-0'>
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-52 md:h-96  object-cover absolute top-0 left-0"
                />
                <div className='w-full h-52 md:h-96 bg-gradient-to-t from-gray-900 via-transparent to-transparent absolute top-0 left-0' />

              </div>
              <div className='absolute text-white bottom-0 left-0 p-5 py-2 md:py-5'>
                <span className="text-base md:text-xl">{article.time} | {article.date}</span>
                <h1 className="font-bold text-lg md:text-4xl line-clamp-2">
                  {article.title}
                </h1>
              </div>
            </div>


            <div className='p-5 pt-0 rounded-b-md bg-white shadow'>
              <div className={`article-${article.slug.replace(/[^a-z0-9]/gi, '-')}`}>
                {article.content}
              </div>
            </div>

          </div>
          <div className="lg:col-span-2 relative z-0 mt-5 hidden lg:block">
            <ReadAlsoSection articles={filteredArticles} />
          </div>
        </div>

      </div>
      <div className=' pr-[10%] pl-[10%] w-full py-5 mt-5 -mb-5 bg-gradient-to-br from-defaultBlue via-[#63C8ED] to-cyan-300 relative overflow-hidden flex justify-center'>
        <LatestArticles articles={filteredArticles} selectedCategory={article.category} />
        <img alt='' src='/images/CircleDotsWhite.svg' className='absolute  -top-16 -right-16 z-10 w-64 h-64 ' />
      </div>

    </div>
  );
};

export default ArticleDetail;